import { mapState } from 'ui.vue3.pinia';
import { vplSiteStore } from '../../store/vplstore';

export const PhoneHeaderMobileIcon = {
    props: {
        tagClass: String
    },
    computed: {
        ...mapState(vplSiteStore, ['templateData'])
    },
    template: `
            <a href="#"
                aria-label="Контакты"
                class="header__middle-contacts-mob js-mob-contacts-btn">
              <svg class="icon icon-tel-mob"><use xlink:href="#icon-tel-mob"></use></svg>
            </a>
    `
}
